import { ApiserviceMelcoModelsDesignElement } from "../../client-api-service";

const isLettering = (item: ApiserviceMelcoModelsDesignElement) =>
  item.type === "Lettering";

const isColor = (item: ApiserviceMelcoModelsDesignElement) => item.type === "Color";

const isDesign = (item: ApiserviceMelcoModelsDesignElement) => item.type === "Design";

const isNotActiveGroupColor = (item: ApiserviceMelcoModelsDesignElement) =>
  !(item.active_color_group_id && item.active_color_group_id.length > 0);

const isEditable = (item: ApiserviceMelcoModelsDesignElement) => !!item.editable;

export const ElementListHelper = {
  isLettering,
  isColor,
  isDesign,
  isNotActiveGroupColor,
  isEditable,
};
